import { useEffect } from "react";
import { useCodesmithEnabledWithCache } from "@/components/sidebar/useCodesmithEnabledCache";

/**
 * Warm the Codesmith dynamic chunk at idle so switching apps via the rail
 * doesn't stall on the chunk download behind SessionSkeleton. Uses
 * requestIdleCallback to avoid competing with first-paint resources; the
 * module cache makes repeat imports free.
 */
export function usePrefetchCodesmithChunk() {
  // Same gate as the rail row: warm unless the org's flag is explicitly false.
  const codesmithEnabled = useCodesmithEnabledWithCache() !== false;
  useEffect(() => {
    if (!codesmithEnabled) return;
    const warm = () => {
      void import("@/components/codesmith/Codesmith");
    };
    if (typeof window !== "undefined" && "requestIdleCallback" in window) {
      const id = window.requestIdleCallback(warm, {
        timeout: 2000
      });
      return () => window.cancelIdleCallback(id);
    }
    const id_0 = setTimeout(warm, 1000);
    return () => clearTimeout(id_0);
  }, [codesmithEnabled]);
}